import NewsPage from "./NewsPage";

export default NewsPage;
